import { useState, useEffect } from "react";
import Block from '../new/block1'; // Composant d'entrée personnalisé

const EditableBlockList = ({ onDiagnosisChange, aiDiagnosis: aiDiagnosisProp, doctorDiagnosis: doctorDiagnosisProp }) => {
  const [doctorDiagnosis, setDoctorDiagnosis] = useState(doctorDiagnosisProp || "");
  const [aiDiagnosis, setAiDiagnosis] = useState(aiDiagnosisProp || "");

  const [isOpen, setIsOpen] = useState(false);

  // Synchronisation avec les données du parent
  useEffect(() => {
    setAiDiagnosis(aiDiagnosisProp || "");
  }, [aiDiagnosisProp]);

  useEffect(() => {
    setDoctorDiagnosis(doctorDiagnosisProp || "");
  }, [doctorDiagnosisProp]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleDoctorDiagnosisChange = (newDiagnosis) => {
    setDoctorDiagnosis(newDiagnosis);
    onDiagnosisChange(newDiagnosis, 'doctorDiagnosis');
  };

  const handleAiDiagnosisChange = (newDiagnosis) => {
    setAiDiagnosis(newDiagnosis);
    onDiagnosisChange(newDiagnosis, 'aiDiagnosis');
  };

  return (
    <div>
      <div className="position-relative">
        <p
          className="py-3 fw-bold text-center"
          style={{ background: '#0056B32B', borderRadius: '15px' }}
          onClick={toggleDropdown}
        >
          Diagnosis
        </p>
        <i
          className="bi bi-caret-down-fill pos1"
          style={{ color: '#0056B3' }}
        ></i>
      </div>

      {isOpen && (
        <div style={{ margin: '0px 40px' }}>
          <div className="mb-4 mt-3 p-3" style={{ border: '1px dashed #0056B3', borderRadius: '10px' }}>
            <p className="p-2 text-center fw-bold" style={{ background: '#0056B317' }}>AI’s generated Diagnosis</p>
            <p>
              {aiDiagnosis
                ? aiDiagnosis
                : <em>En attente du diagnostic généré par l’IA...</em>}
            </p>
          </div>

          <div>
            <Block
              initialLabel="Doctor’s diagnosis"
              initialContent={doctorDiagnosis}
              onContentChange={handleDoctorDiagnosisChange}
            />
          </div>

          {/* <div>
            <Block
              initialLabel="AI’s Diagnosis"
              initialContent={aiDiagnosis}
              readOnly={true}
              onContentChange={() => { }}
            />
          </div> */}
        </div>
      )}
    </div>
  );
};

export default EditableBlockList;
